import { Link } from 'react-router-dom'
import HeroCTA from '../components/HeroCTA'
import './AboutPage.css'

function AboutPage() {
  return (
    <div className="about-page">
      <section className="page-hero">
        <div className="container">
          <h1>About Laboratory Specialists</h1>
          <p className="page-hero-subtitle">
            Your trusted partner for laboratory parts knowledge, product supply, and service expertise
          </p>
        </div>
      </section>

      <section className="about-content">
        <div className="container">
          <div className="about-section">
            <h2>Our Experience</h2>
            <div className="experience-stats">
              <div className="experience-stat">
                <div className="stat-number">700+</div>
                <div className="stat-label">Successful Installations</div>
              </div>
             
              <div className="experience-stat">
                <div className="stat-number">35+</div>
                <div className="stat-label">Years of Experience (Founded 1988)</div>
              </div>
            </div>
          </div>

          <div className="about-section">
            <h2>Our Mission</h2>
            <p>
              At Laboratory Specialists, we're dedicated to making it as easy as possible for you to have 
              exactly the lab you want. Our mission is to provide exceptional parts knowledge, 
              comprehensive product supply, and professional service expertise to businesses and universities.
            </p>
            <p>
              With extensive experience in laboratory equipment and parts, we've built a reputation for 
              excellence, reliability, and customer satisfaction. We understand that every lab is unique, 
              and we work closely with our clients to deliver customized solutions that meet their specific needs.
            </p>
            <p>
              Our focus is on parts knowledge and service - helping you find the right products and ensuring 
              they're properly installed and configured. We offer a comprehensive, non-brand specific selection 
              of laboratory equipment, making it easy for you to get exactly what you need.
            </p>
          </div>

          <div className="about-section">
            <h2>Why Choose Us</h2>
            <div className="why-choose-grid">
              <div className="why-choose-item">
                <h3>Extensive Parts Knowledge</h3>
                <p>
                  Our team has deep expertise in laboratory parts and components. We understand 
                  the nuances of different equipment and can help you find exactly what you need.
                </p>
              </div>
              <div className="why-choose-item">
                <h3>Comprehensive Product Supply</h3>
                <p>
                  We offer a wide selection of non-brand specific laboratory equipment and parts,
                  sourced from ISO 9001:2015 certified manufacturers so you get consistent, verifiable
                  quality. From casework to fume hoods, we have what you need.
                </p>
              </div>
              <div className="why-choose-item">
                <h3>Service Expertise</h3>
                <p>
                  Professional installation and setup services ensure your lab equipment is properly 
                  configured and ready to use. We handle the details so you don't have to.
                </p>
              </div>
              <div className="why-choose-item">
                <h3>Easy Solutions</h3>
                <p>
                  We make it as easy as possible for you to have exactly the lab you want. From 
                  product selection to installation, we streamline the entire process.
                </p>
              </div>
              <div className="why-choose-item">
                <h3>Project Management for Facilities Managers</h3>
                <p>
                  We provide dedicated project management support to help facilities managers coordinate 
                  lab installations, track timelines, and ensure smooth execution from planning through completion.
                </p>
              </div>
              <div className="why-choose-item">
                <h3>Plan Reviews for General Contractors</h3>
                <p>
                  Our team offers plan review services to help general contractors identify potential issues 
                  early, ensure lab specifications are met, and avoid costly changes during construction.{' '}
                  <Link to="/general-contractors">Learn More About Our Lab Buildout Support for GCs</Link>.
                </p>
              </div>
            </div>
          </div>

          <div className="about-section">
            <h2>Certifications & Accreditations</h2>
            <p>
              We maintain certifications and accreditations from leading industry organizations 
              to ensure we meet the highest standards of quality and professionalism.
            </p>
            <ul className="certifications-list">
              <li>Certified woman owned business WBE 12598</li>
              <li>CCB License 115000</li>
              <li>Registered with SAM.gov</li>
            </ul>
          </div>
        </div>
      </section>

      <section className="about-cta-section">
        <div className="container">
          <div className="about-cta-content">
            <h2>Let's Work Together</h2>
            <p>
              Ready to discuss your lab equipment needs? Schedule a free consultation with our 
              experts today.
            </p>
            <HeroCTA />
          </div>
        </div>
      </section>
    </div>
  )
}

export default AboutPage
